<template>
  <div class="go-in">
    <div class="section">
      <div class="section-content">
        <!-- <p
          style="
            margin-top: 100px;
            margin-left: 10px;
            margin-bottom: 10px;
            font-weight: 800;
          "
        >
          联系我们
        </p> -->

        <h3 style="display: flex; justify-content: center; margin: 50px 0px;" >
          联系我们
        </h3>
        <!-- <hr> -->
        <!-- <el-divider class="el-divider-active"> </el-divider> -->
        <div style="width: 80%; margin-left: 10%;height: 665px;">
          <el-descriptions title="" :column="1" :size="size" border>
            <el-descriptions-item>
              <template slot="label"> 单位名称: </template>
              焦作市疾病预防控制中心
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 电话： </template>
              (0391)8861306&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(0391)8861309
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 单位地址： </template>
              焦作市高新区世纪西路500号
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 联系人员： </template>
              
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 业务联系电话： </template>
              (0391)8861306&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(0391)8861309
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 技术服务电话： </template>
              13663867531
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 联系邮箱： </template>
              jzcdczfs@163.com
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
      }
    }
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
</style>